// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#friendListFriends .chat-user .label-secondary,
#friendListBlockeds .chat-user .label-secondary,
#friendListFriends .chat-user .label-success,
#friendListBlockeds .chat-user .label-success {
  margin-left: -35px;
  z-index: 1;
}
#friendListFriends .chat-user .label-secondary,
#friendListBlockeds .chat-user .label-secondary {
  background-color: #9c9c9c;
}
#kt_quick_sidebar {
  overflow: auto;
  height: 100vh;
}
#kt_quick_sidebar .quick-panel-actions {
  text-align: right;
}
span.flaticon2-website.icon-lg {
  margin-top: 10px !important;
}
.chat-image-preview {
  width: 235px;
  margin-top: 5px;
}
.chat-file-preview {
  margin-top: 15px;
  text-align: left;
  padding: 5px;
  background-color: #625dbb;
  display: block;
  color: #d9d9d9;
}
.chat-file-preview i.la-file {
  margin-right: 2px;
}
.chat-file-preview i.la-download {
  margin-top: 2px;
}
.chat-file-preview:hover {
  color: #fff;
}
.chat-file-preview:hover i {
  text-decoration: none;
}
.chat-link-message {
  display: block;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  margin-top: 15px;
  text-align: left;
  padding: 5px;
  background-color: #3598dc;
  color: #f7f7f7;
}
#btnLinkShare {
  margin-top: -1em !important;
}
#btnLinkShare .p-button-icon-left {
  top: 56% !important;
}
body .p-fileupload .p-fileupload-buttonbar.p-widget-header {
  border: none !important;
  background-color: #fff !important;
}
#chatMessageForm .p-fileupload-content {
  display: none;
}
#chatMessageForm .p-fileupload .p-fileupload-buttonbar {
  background: transparent !important;
}
#chatMessageForm .btn.btn-icon {
  color: #A1A5B7 !important;
  background: transparent !important;
}
#chatMessageForm .btn.btn-icon i {
  color: #A1A5B7 !important;
}
#chatMessageForm .btn.btn-icon:hover {
  color: #009EF7 !important;
  background-color: #F1FAFF !important;
}
#chatMessageForm .btn.btn-icon:hover i,
#chatMessageForm .btn.btn-icon:hover .p-button {
  color: #009EF7 !important;
}
#chatMessageForm .p-fileupload-choose.p-button,
#chatMessageForm .p-fileupload-choose.p-button .p-widget,
#chatMessageForm .fileinput-button {
  color: #A1A5B7 !important;
  background: transparent !important;
}
#chatMessageForm .p-fileupload-buttonbar {
  margin: 0px !important;
  padding: 0px !important;
  border: none;
}
#chatMessageForm .p-fileupload-buttonbar .p-button-icon-left {
  top: 38% !important;
  margin-right: 0px;
}
#chatMessageForm .p-fileupload-choose.p-focus {
  box-shadow: none;
}
#chatMessageForm .p-fileupload-choose {
  width: 100% !important;
}
#chatMessageForm .p-fileupload-choose {
  border: none !important;
}
#chatMessageForm .ui-fileupload-content {
  display: none;
}
#chatMessageForm .p-button {
  min-width: 0!important;
}
#chatMessageForm .p-fileupload .p-fileupload-buttonbar .p-button {
  margin-right: 0!important;
}
[dir="rtl"] #kt_quick_sidebar .quick-panel-actions {
  padding-right: 10px;
}
#kt_drawer_chat_messenger .card-body {
  max-height: calc(100vh - 230px);
}
#kt_chat_contacts_header .card-title {
  width: 60%;
  margin: 0;
}
#kt_chat_contacts_header .card-toolbar {
  width: 40%;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/chat/chat-bar.component.less"],"names":[],"mappings":"AAAA;;;;EAII,kBAAA;EACA,UAAA;AACJ;AAEA;;EAEI,yBAAA;AAAJ;AAGA;EACI,cAAA;EACA,aAAA;AADJ;AAIA;EACI,iBAAA;AAFJ;AAKA;EACI,2BAAA;AAHJ;AAMA;EACI,YAAA;EACA,eAAA;AAJJ;AAOA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;AALJ;AADA;EASQ,iBAAA;AALR;AAJA;EAaQ,eAAA;AANR;AASI;EACI,WAAA;AAPR;AAMI;EAIQ,qBAAA;AAPZ;AAYA;EACI,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AAVJ;AAaA;EACI,2BAAA;AAXJ;AAUA;EAGQ,mBAAA;AAVR;AAeA;EACI,uBAAA;EACA,iCAAA;AAbJ;AAgBA;EAGQ,aAAA;AAhBR;AAaA;EAOQ,kCAAA;AAjBR;AAUA;EAWQ,yBAAA;EACA,kCAAA;AAlBR;AAMA;EAeY,yBAAA;AAlBZ;AAqBQ;EACI,yBAAA;EACA,oCAAA;AAnBZ;AAiBQ;;EAKQ,yBAAA;AAlBhB;AALA;;;EA+BQ,yBAAA;EACA,kCAAA;AArBR;AAXA;EAoCQ,sBAAA;EACA,uBAAA;EACA,YAAA;AAtBR;AAhBA;EAyCY,mBAAA;EACA,iBAAA;AAtBZ;AA2BQ;EACI,gBAAA;AAzBZ;AAvBA;EAqDQ,sBAAA;AA3BR;AA1BA;EAyDQ,uBAAA;AA5BR;AA7BA;EA6DQ,aAAA;AA7BR;AAhCA;EAiEQ,sBAAA;AA9BR;AAnCA;EAqEQ,yBAAA;AA/BR;AAoCA;EAIQ,mBAAA;AArCR;AA0CE;EACI,+BAAA;AAxCN;AA2CA;EAEQ,UAAA;EACA,SAAA;AA1CR;AAuCA;EAOQ,UAAA;EACA,SAAA;AA3CR","sourcesContent":["#friendListFriends .chat-user .label-secondary,\n#friendListBlockeds .chat-user .label-secondary,\n#friendListFriends .chat-user .label-success,\n#friendListBlockeds .chat-user .label-success {\n    margin-left: -35px;\n    z-index: 1;\n}\n\n#friendListFriends .chat-user .label-secondary,\n#friendListBlockeds .chat-user .label-secondary {\n    background-color: #9c9c9c;\n}\n\n#kt_quick_sidebar{\n    overflow: auto;\n    height: 100vh;\n}\n\n#kt_quick_sidebar .quick-panel-actions {\n    text-align: right;\n}\n\nspan.flaticon2-website.icon-lg{\n    margin-top: 10px !important;\n}\n\n.chat-image-preview {\n    width: 235px;\n    margin-top: 5px;\n}\n\n.chat-file-preview {\n    margin-top: 15px;\n    text-align: left;\n    padding: 5px;\n    background-color: #625dbb;\n    display: block;\n    color: #d9d9d9;\n\n    i.la-file {\n        margin-right: 2px;\n    }\n\n    i.la-download {\n        margin-top: 2px;\n    }\n\n    &:hover {\n        color: #fff;\n\n        i {\n            text-decoration: none;\n        }\n    }\n}\n\n.chat-link-message {\n    display: block;\n    text-overflow: ellipsis;\n    overflow-x: hidden;\n    white-space: nowrap;\n    margin-top: 15px;\n    text-align: left;\n    padding: 5px;\n    background-color: #3598dc;\n    color: #f7f7f7;\n}\n\n#btnLinkShare{\n    margin-top:-1em !important;\n    .p-button-icon-left{\n        top: 56% !important;\n    }\n}\n\n\nbody .p-fileupload .p-fileupload-buttonbar.p-widget-header {\n    border: none !important;\n    background-color: #fff !important;\n}\n\n#chatMessageForm{\n\n    .p-fileupload-content{\n        display: none;\n    }\n\n    .p-fileupload .p-fileupload-buttonbar{\n        background: transparent !important;\n    }\n\n    .btn.btn-icon{\n        color: #A1A5B7 !important;\n        background: transparent !important;\n\n        i{\n            color: #A1A5B7 !important;\n        }\n\n        &:hover{\n            color: #009EF7 !important;\n            background-color: #F1FAFF !important;\n\n            i, .p-button{\n                color: #009EF7 !important;\n            }\n        }\n    }\n\n    .p-fileupload-choose.p-button,\n    .p-fileupload-choose.p-button .p-widget,\n    .fileinput-button{\n        color: #A1A5B7 !important;\n        background: transparent !important;\n    }\n\n    .p-fileupload-buttonbar{\n        margin:0px !important;\n        padding:0px !important;\n        border:none;\n\n        .p-button-icon-left{\n            top: 38% !important;\n            margin-right: 0px;\n        }\n    }\n\n    .p-fileupload-choose{\n        &.p-focus{\n            box-shadow: none;\n        }\n    }\n\n    .p-fileupload-choose {\n        width :100% !important;\n    }\n\n    .p-fileupload-choose {\n        border: none !important;\n    }\n\n    .ui-fileupload-content{\n        display: none;\n    }\n\n    .p-button{\n        min-width: 0!important;\n    }\n\n    .p-fileupload .p-fileupload-buttonbar .p-button{\n        margin-right: 0!important;\n    }\n\n}\n\n[dir=\"rtl\"] {\n    #kt_quick_sidebar {\n\n      .quick-panel-actions {\n        padding-right: 10px;\n      }\n    }\n  }\n\n  #kt_drawer_chat_messenger .card-body{\n      max-height: calc(~\"100vh - 230px\");\n  }\n\n#kt_chat_contacts_header{\n    .card-title{\n        width: 60%;\n        margin: 0;\n    }\n\n    .card-toolbar{\n        width: 40%;\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
